export enum AppTenant {
  Example = 'example',
  League = 'league',
  LeagueDC = 'league-dc',
  PCHealth = 'pchealth',
  HighmarkIel = 'highmark-iel',
  HighmarkBeneficity = 'highmark-beneficity',
  HighmarkAllMyHealth = 'highmark-allmyhealth',
  HighmarkEnGen = 'highmark-engen',
  Manulife = 'manulife',
  OvatientMetroHealth = 'ovatient-metrohealth',
  XOHealth = 'xohealth',
  Cigna = 'cigna',
  Premera = 'premera',
  SCAN = 'scan',
  SCFHP = 'scfhp',
  Baptist = 'baptist',
  Reference = 'reference',
  MedibankValencia = 'medibank-valencia',
  MedibankMyMedibank = 'medibank-mymedibank',
  TelusABHealth = 'telus-abhealth',
  TelusHealthOne = 'telus-healthone',
  TelusHealthOneAU = 'telus-healthone-au',
  TrilliumConnect = 'trillium-connect',
  Quest = 'quest',
  BCBSWyoming = 'bcbs-wyoming',
  CareSource = 'caresource',
  EmblemHealth = 'emblem-health',
  EmblemHealthUat = 'em-health-uat',
  Geisinger = 'geisinger',
  MedibankPatientPortal = 'medibank-pp',
  SouthernCross = 'southerncross',
  PtthHarvardPilgrim = 'ptth-harvard-pilgrim',
  PtthTufts = 'ptth-tufts',
}

export type TenantId = `${AppTenant}`;

export type ViteAppEnvironment = 'staging' | 'production';
